import card1_info from '../../images/card/card1_info_en.svg'
import card1_search from '../../images/card/card1_search_en.svg'
import card2 from '../../images/card/card2_chat_en.svg'
import card3_chat_total from '../../images/card/card3_chat_all_en.svg'
import card3_chat_team from '../../images/card/card3_chat_team_en.svg'
import card3_chat_doc from '../../images/card/card3_chat_doc_en.svg'

const data = [
  {
    img: [card1_info, card1_search],
    title: ['Easy and cosy', 'business communication', 'like fireside chat'],
    sub: ['Virtualizing messaging across business  applications and systems', 'Allowing users to easily find documents in the messenger']
  },
  {
    img: [card2],
    title: ['Securely ', 'protect', 'important files', 'in chat threads'],
    sub: ['Only users with permission can create and access document chats']
  },
  {
    img: [card3_chat_total, card3_chat_team, card3_chat_doc],
    title: ['Content-centric chat', 'enables collaboration', 'for high-quality content'],
    sub: [
      'Managing chats by content or user for user convinience',
      'Providing chats based on organization chart for enterprises',
      'Automatically inviting users with permissions to a',
      'document chat room to create a quick and efficient', 
      'collaboration environment.'
    ]
}]

export default data;